import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux'
import AddStudent from './AddStudent'
import "datatables.net-bs4/css/dataTables.bootstrap4.css"
// import 'datatables.net-responsive-bs4/css/responsive.bootstrap4.min.css';
import Modal from '../../../../basic-component/Modal';
import Student from './Student';
const $ = require('jquery');


require('jszip');
require('pdfmake');
$.DataTable = require('datatables.net-bs4');
require('datatables.net-buttons-bs4');
require('datatables.net-buttons/js/buttons.colVis.js');
require('datatables.net-buttons/js/buttons.flash.js');
require('datatables.net-buttons/js/buttons.html5.js');
require('datatables.net-buttons/js/buttons.print.js');
require('datatables.net-keytable-bs4');

class Students extends Component {

    state = {
        showModalAddStudent: true,
        studentLenght: this.props.studentData.length,
        currentStudent: {},
    }
    showStudentInfo = (s) => {

        this.setState({ currentStudent: s });
    }

    setTableData() {
        let studentData = this.props.studentData;
        this.$el = $(this.el);
        var table = this.$el.DataTable({
            // lengthChange: false,
            dom: 'lBfrtip',
            data: studentData,
            columns: [
                { data: 'roll' },
                { data: 'name' },
                { data: 'classes' },
                { data: 'parent' },
                // { data: 'address' },
                { data: 'Phone' },
                // { data: 'dob' },
                // { data: 'email' },

                // { data: 'allergie' },
                // { data: 'allergie' },

                { data: 'medication' },
                { data: 'username' },

            ],
            columnDefs: [
                {
                    data: null,
                    defaultContent: "Please Open In Large Screen..",
                    targets: 7,
                    createdCell: (td, cellData, rowData, row, col) => {

                        ReactDOM.render(
                            <div>
                                <button className='btn btn-info btn-sm' data-toggle="modal" data-target="#studentInfoModal" onClick={() => this.showStudentInfo(rowData)}>
                                    <i className='fa fa-edit'></i>
                                </button>&nbsp;
            <button className='btn btn-danger btn-sm' data-toggle="modal" data-target="#deleteAlert" onClick={() => this.props.deleteStudentToStore(rowData.roll)}>
                                    <i className='fa fa-trash-o'></i>
                                </button>
                            </div>,
                            td);


                    }
                },

            ],
            responsive: true,

            destroy: true,

            buttons: [
                // {
                //     extend: 'pdf',
                //     text: 'PDF',
                //     className: 'btn btn-success'
                // },
                {
                    extend: 'csv',
                    text: 'CSV',
                    title: "Students Records",
                    className: 'btn btn-success btn-sm'
                },
                {
                    extend: 'print',
                    text: 'Print',
                    title: "<h1 class='text-center'>Student Record</h1>",
                    className: 'btn btn-success btn-sm'
                }
            ]
        });
        table.buttons().container().appendTo(".export-buttons ");
        // $('#myTable tbody').on('dblclick', 'tr', function () {
        //     var data = table.row(this).data();
        //     console.log(data);
        //     alert('You clicked on ' + data.name + '\'s row');
        // });
    }
    shouldComponentUpdate(nextProps, nextState) {

        return true
    }
    componentDidUpdate() {
        console.log("Table Updated")
        this.setTableData()
    }

    componentDidMount() {


        this.setTableData();
        console.log("loded")
    }
    render() {
        const newStudent = {
            roll: 12,
            name: "Deepak Kumar",
            classes: "Std 1",
            parent: "Ghanshayam Vishwakarma",
            address: "Japla",
            Phone: "8083717128"
        };
        let students = (
            <div>
                {/* <h2 className="text-secondary" style={{ paddingLeft: "0.5rem", paddingTop: "1rem" }}>Student</h2> */}
                <Modal header="Are you sure." modalWidth="modal-sm" modalId="deleteAlert" action="Delete">If you click on Delete button then this student will no longer in database record.</Modal>
                <div className="card card-design-2">
                    <div className="card-header bg-primary text-white">
                        Student List by Classes
                    </div>
                    <div className="card-body">
                        <div className="row">
                            <div className="col-lg-4 col-sm-12">
                                <div className="row">
                                    <div className="mr-1 pd-1"> Select Class</div>
                                    <select className="form-control"><option>Std 1</option></select>
                                </div>
                            </div>
                            <div className="col-lg-8 col-sm-12 text-right export-buttons">
                                {/* <Link to={this.props.match.url + "/Addstudent"} className="btn btn-primary btn-sm"><i className="fa fa-plus"></i> Add Student</Link>&nbsp; */}
                                <button className="btn btn-primary btn-sm" data-toggle="modal" data-target="#myModal" ><i className="fa fa-plus"></i> Add Student</button>&nbsp;
                                <button className="btn btn-info btn-sm" onClick={() => this.props.addStudentToStore(newStudent)}> Quick Add student</button>
                                {/* <div className="export-buttons"></div> */}
                            </div>
                        </div>
                        <div className="row">
                            <div className=" table-responsive" style={{ padding: "10px" }}>
                                <table id="myTable" className="table table-hover table-bordered dt-responsive nowrap" width="100%" ref={el => this.el = el} >
                                    <thead>
                                        <tr>
                                            <th>Roll No</th>
                                            <th>Full Name</th>
                                            <th>Class</th>
                                            <th>Parent</th>
                                            {/* <th>Address</th> */}
                                            <th>Phone</th>
                                            {/* <th>Date of B/irth</th> */}
                                            {/* <th>Email</th> */}

                                            {/* <th>Allergie/</th> */}

                                            <th>Medication</th>
                                            <th>Username</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
        return (
            <div>


                <Modal header="Add Student" modalWidth="modal-xl" modalId="myModal" action="Add Student"><AddStudent /></Modal>
                <Modal header="Student Info" modalWidth="modal-xl" modalId="studentInfoModal" action="Update"><Student studentDetail={this.state.currentStudent} /></Modal>
                {students}

            </div>

        );
    }
}
const mapStateToProps = state => {
    return {
        isUserLoggedIn: state.isAuthenticated,
        studentData: state.studentData
    };
}
const mapDispatchToProps = dispatch => {
    return {
        addStudentToStore: (newStudent) => dispatch({ type: 'AddStudent', studentData: newStudent }),
        deleteStudentToStore: (roll) => dispatch({ type: "DeleteStudent", roll: roll })
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Students);